module.exports = {
          srcSet: __webpack_public_path__ + "6ff5808d81b76f6c86b97c99f1d0602e-50.png"+" 50w",
          images:[ {path: __webpack_public_path__ + "6ff5808d81b76f6c86b97c99f1d0602e-50.png",width: 50,height: 38}],
          src: __webpack_public_path__ + "6ff5808d81b76f6c86b97c99f1d0602e-50.png",
          toString:function(){return __webpack_public_path__ + "6ff5808d81b76f6c86b97c99f1d0602e-50.png"},
          
          width: 50,
          height: 38
        }